<template>
    <div id="container" type="vdpp">
        <div class="page page-agentmeetagents" v-ga:page="{pageType: glb.pageType, glb: glb}" v-ga:request="{pageType:'vagentmeetagents'}">
            <mvtHeader />
            <mvtWelcome>
                <template v-slot:img>
                    <img :src="glb.cdnUrl + 'vimages/agent-welcome.webp'" alt="Welcome Movoto Agent Home" fetchpriority="auto"/>
                </template>
                <template v-slot:content>
                    <h1><b class="f0 text-bold">Match with local agents.</b></h1>
                    <agentInputGeo />
                    <div class="f5">You don't have to home alone. Get matched with a top local Real Estate agent and feel supported in your journey — from start to close.</div>
                </template>
            </mvtWelcome>
            <mvtFooter />
            <mvtPopSignin />
            <mvtDialogCenter></mvtDialogCenter>
        </div>
    </div>
</template>
<script src="./page-agentmeetagents.js"></script>
<style lang="scss">
@use "./page-agentmeetagents.scss" as *;
</style>